import { apiService } from '../api';
import { UserResponse } from '../../types/dtos';
import { authorizedDevicesService, UserDeviceBypassApiResponse } from './authorizedDevicesService';
import { buildSetUserDeviceBypassApiRequest } from './deviceUserBypassApi';
import {
  DeviceUserExemptionViewModel,
} from './deviceUserExemptionMappers';
import {
  isUserDeviceBypassActive,
  mapUserToDeviceUserExemptionViewModel,
} from './deviceUserBypassMappers';

export type {
  DeviceUserExemptionViewModel,
} from './deviceUserExemptionMappers';

export interface GrantDeviceUserExemptionRequest {
  userId: string;
  /** null = permanent exemption */
  expiresAtUtc?: string | null;
}

const LIST_USERS_PAGE_SIZE = 500;

async function fetchActiveUsers(): Promise<UserResponse[]> {
  const page = await apiService.getUsers({ page: 1, pageSize: LIST_USERS_PAGE_SIZE });
  return page.items.filter((u) => u.isActive && !u.isDeleted);
}

class DeviceUserExemptionsService {
  async list(): Promise<DeviceUserExemptionViewModel[]> {
    const users = await fetchActiveUsers();
    return users
      .filter((user) => isUserDeviceBypassActive(user))
      .map(mapUserToDeviceUserExemptionViewModel)
      .sort((a, b) => a.displayName.localeCompare(b.displayName, 'pt-BR'));
  }

  async grant(payload: GrantDeviceUserExemptionRequest): Promise<UserDeviceBypassApiResponse> {
    const body = buildSetUserDeviceBypassApiRequest(true, payload.expiresAtUtc ?? null);
    return authorizedDevicesService.setUserDeviceBypass(payload.userId, body);
  }

  async revoke(userId: string): Promise<UserDeviceBypassApiResponse> {
    const body = buildSetUserDeviceBypassApiRequest(false, null);
    return authorizedDevicesService.setUserDeviceBypass(userId, body);
  }
}

export const deviceUserExemptionsService = new DeviceUserExemptionsService();
